export default "__VITE_ASSET__BL7K1hjq__"